import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAG = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M0 25c0 1.712.173 3.384.5 5L25 31.522 49.498 30c.329-1.616.501-3.288.501-5a25.11 25.11 0 0 0-.5-5l-24.5-1.522L.502 20A25.108 25.108 0 0 0 0 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M49.499 29.999H.5c2.316 11.411 12.404 20 24.499 20 12.094 0 22.182-8.589 24.499-20Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M.5 20H49.5C47.182 8.589 37.094 0 24.999 0 12.906 0 2.818 8.589.502 20Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M35.87 20H14.13l4.442-2.09-2.365-4.3 4.823.922.61-4.872L25 13.243l3.36-3.583.61 4.872 4.823-.923-2.365 4.302L35.87 20Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M0 25c0 13.807 11.193 25 25 25L5 10a24.888 24.888 0 0 0-5 15ZM25 50c13.806 0 25-11.193 25-25 0-5.628-1.861-10.822-5-15L25 50Z"
}));
FlagAG.displayName = 'FlagAG';
export default withFlagWrapper(FlagAG);
//# sourceMappingURL=index.js.map